import { css, RuleSet } from 'styled-components'

export const tabletStyles = (style: RuleSet) => css`
  @media screen and (max-width: 767px) {
    ${style}
  }
`

export const mobileStyles = (style: RuleSet) => css`
  @media screen and (max-width: 639px) {
    ${style}
  }
`
